export const portfolioData = [
  {
    id: 1,
    slug: "inmobi-real-state",
    heroImage: "/assets/img/portfolio/inmobi1296x700.webp",
    imageUrl: "/assets/img/portfolio/inmobi746 × 540.webp",
    client: "Inmobi Real Estate Group",
    date: "June 15, 2024",
    category: "portfolio.p1.category",
    type: "portfolio.p1.type",
    title: "portfolio.p1.title",
    parentClass: "col-lg-7",
    description: "portfolio.p1.description",
    challenge: "portfolio.p1.challenge",
    solution: "portfolio.p1.solution",
    result: "portfolio.p1.result",
  },
  {
    id: 2,
    slug: "procesos-migratorios-apm",
    heroImage: "/assets/img/portfolio/apm1296x700.webp",
    imageUrl: "/assets/img/portfolio/apm526x540.webp",
    client: "APM Legal Services",
    date: "August 10, 2024",
    category: "portfolio.p2.category",
    type: "portfolio.p2.type",
    title: "portfolio.p2.title",
    parentClass: "col-lg-7",
    description: "portfolio.p2.description",
    challenge: "portfolio.p2.challenge",
    solution: "portfolio.p2.solution",
    result: "portfolio.p2.result",
  },
  {
    id: 3,
    slug: "settleu",    
    heroImage: "/assets/img/portfolio/settleu 1292x700.webp",
    imageUrl: "/assets/img/portfolio/settleu 1292x700.webp",
    client: "settleu Relocation Services",
    date: "May 20, 2024",
    category: "portfolio.p3.category",
    type: "portfolio.p3.type",
    title: "portfolio.p3.title",
    parentClass: "col-lg-7",
    description: "portfolio.p3.description",
    challenge: "portfolio.p3.challenge",
    solution: "portfolio.p3.solution",
    result: "portfolio.p3.result",
  },
  {
    id: 4,
    slug: "dr-julia-scheinecker",
    heroImage: "/assets/img/portfolio/juliascheinecker1296x700.webp",
    imageUrl: "/assets/img/portfolio/juliascheinecker520x540.webp",
    client: "Dr. Julia Scheinecker",
    date: "July 5, 2024",
    category: "portfolio.p4.category",
    type: "portfolio.p4.type",
    title: "portfolio.p4.title",
    parentClass: "col-lg-7",
    description: "portfolio.p4.description",
    challenge: "portfolio.p4.challenge",
    solution: "portfolio.p4.solution",
    result: "portfolio.p4.result",
  },
  {
    id: 5,
    slug: "sigma-clinica-dental",
    heroImage: "/assets/img/portfolio/sigma1296x700.webp",
    imageUrl: "/assets/img/portfolio/sigmaclinicadental746x540.webp",
    client: "Sigma Dental Group",
    date: "July 5, 2024",
    type: "portfoio.p6.type",
    date: "September 12, 2024",
    category: "portfolio.p5.category",
    title: "portfolio.p5.title",
    parentClass: "col-lg-7",
    description: "portfolio.p5.description",
    challenge: "portfolio.p5.challenge",
    solution: "portfolio.p5.solution",
    result: "portfolio.p5.result",
  },
  {
    id: 6,
    slug: "kaufast",
    heroImage: "/assets/img/portfolio/kaufastseo1290x700.webp",
    imageUrl: "/assets/img/portfolio/kaufastseo1290x700.webp",
    client: "Kaufast SEO Agency",
    type: "portfolio.p6.type",
    date: "October 1, 2024",
    category: "portfolio.p6.category",
    title: "portfolio.p6.title",
    parentClass: "col-lg-7",
    description: "portfolio.p6.description",
    challenge: "portfolio.p6.challenge",
    solution: "portfolio.p6.solution",
    result: "portfolio.p6.result",
  },
];

export const allPortfolio = [...portfolioData];
